__turbopack_context__.v({
  "address": "visit-section-module__B4d3xq__address",
  "backdrop": "visit-section-module__B4d3xq__backdrop",
  "badge": "visit-section-module__B4d3xq__badge",
  "buses": "visit-section-module__B4d3xq__buses",
  "changeNote": "visit-section-module__B4d3xq__changeNote",
  "content": "visit-section-module__B4d3xq__content",
  "dateTag": "visit-section-module__B4d3xq__dateTag",
  "directions": "visit-section-module__B4d3xq__directions",
  "eq": "visit-section-module__B4d3xq__eq",
  "hours": "visit-section-module__B4d3xq__hours",
  "hoursColumn": "visit-section-module__B4d3xq__hoursColumn",
  "label": "visit-section-module__B4d3xq__label",
  "landmark": "visit-section-module__B4d3xq__landmark",
  "leader": "visit-section-module__B4d3xq__leader",
  "location": "visit-section-module__B4d3xq__location",
  "muted": "visit-section-module__B4d3xq__muted",
  "note": "visit-section-module__B4d3xq__note",
  "notice": "visit-section-module__B4d3xq__notice",
  "noticeBody": "visit-section-module__B4d3xq__noticeBody",
  "noticeIcon": "visit-section-module__B4d3xq__noticeIcon",
  "noticeIn": "visit-section-module__B4d3xq__noticeIn",
  "nowrap": "visit-section-module__B4d3xq__nowrap",
  "routes": "visit-section-module__B4d3xq__routes",
  "row": "visit-section-module__B4d3xq__row",
  "section": "visit-section-module__B4d3xq__section",
  "status": "visit-section-module__B4d3xq__status",
  "today": "visit-section-module__B4d3xq__today",
  "todayCompact": "visit-section-module__B4d3xq__todayCompact",
  "todayIn": "visit-section-module__B4d3xq__todayIn",
  "todayItem": "visit-section-module__B4d3xq__todayItem",
  "week": "visit-section-module__B4d3xq__week",
});
